export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0xb013be1D0D380C13B58e889f412895970A2Cf228",
  eulerSwapV1Implementation: "0xc35a0FDA69e9D71e68C0d9CBb541Adfd21D6B117",
  eulerSwapV1Periphery: "0x208fF5Eb543814789321DaA1B5Eb551881D16b06",
} as const
